


































import {Component, Prop, Vue} from "vue-property-decorator";
import UserInput from "@/components/users/Input.vue";
import UserDisplay from "@/components/users/Display.vue";
import UserConfirm from "@/components/users/Confirm.vue";
import UserResult from "@/components/users/Result.vue";

import User from "@/consoleapi/api/user";
// import tokens from "@/authorization/tokens";
import {mapGetters} from "vuex";

@Component({
    components: {
        UserInput,
        UserDisplay,
        UserConfirm,
        UserResult
    },
    computed:
        mapGetters({
            progress:'users/progress'
        }),
})
export default class Account extends Vue {
    private inputName = '';
    private inputKana = '';
    private inputPhoneNumber = '';
    private inputEmail = '';
    private inputConfirm = false;
    private progress: string | null | undefined;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    getInputConfirm(confirm: boolean) {
        this.inputConfirm = confirm;
    }

    public getName(inputName: string) {
        this.inputName = inputName;
    }

    public getKana(inputKana: string) {
        this.inputKana = inputKana;
    }

    public getPhoneNumber(inputPhoneNumber: string) {
        this.inputPhoneNumber = inputPhoneNumber;
    }

    mounted() {
        const user = new User();
        user.setBearerToken(this.bearerToken);
        user.show(this.accountId, this.userId).then(response => {
            const user = response.data.user;
            this.inputEmail = user.email;
            this.inputName = user.name;
            this.inputKana = user["custom:name_kana"];
            this.inputPhoneNumber = user.phone_number.replace(/\+81/, '0');
        }).catch(error => {
            //console.log(error.response);
        });
    }

    beforeDestroy() {
        this.$store.dispatch('users/pushProgress', 'display');
    }
}
